import React, { FC } from 'react';
import Button from '@app/shared/components/button/Button';
import { ButtonAppearance } from '@app/shared/components/button/button-enums';
import { PerYearCapitalStructureChartInstrument } from '@app/modules/projects/dashboard/shared/per-year-capital-structure/per-year-capital-structure-chart-types';

interface PerYearCapitalStructureChartBlockInstrumentProps {
  instrument: PerYearCapitalStructureChartInstrument;
  className: string;
  onClick?: () => void;
}

const PerYearCapitalStructureChartInstrumentBlock: FC<
  PerYearCapitalStructureChartBlockInstrumentProps
> = ({ instrument, onClick, className }): JSX.Element => (
  <div
    key={'instrument-tooltip-wrapper' + instrument.id}
    style={{ width: instrument.proportionOfRank * 100 + '%' }}>
    <Button
      data-testid="instrument-block"
      appearance={ButtonAppearance.CLEAN}
      ignoreReadOnly
      className={className}
      onClick={
        onClick
          ? (event) => {
              event.stopPropagation();
              onClick();
            }
          : undefined
      }
    />
  </div>
);

export default React.memo(PerYearCapitalStructureChartInstrumentBlock);
